import { store } from 'Store/store.index';
import axios from 'axios';
// import qs from 'qs';
import _get from 'lodash/get';
import { HttpRequest } from './request.utils';
import { URL_CWS_API } from './constants';
import { baseUrlApis } from './index';

export default class WanFangPaperCheckApis extends HttpRequest {
	constructor() {
		super();
		this.initialize();
		this.CPDFURI = null;
		this.TRANSFERAPI = '/tools/wf-transfer';
	}
	initialize = () => {
		try {
			baseUrlApis.getBaseUrlBy(URL_CWS_API).then((data) => {
				this.CPDFURI = data;
				const axiosClient = axios.create({
					baseURL: `${this.CPDFURI}/cpdfapi/v1/`,
				});

				super.initialize(axiosClient, () => {
					let responseCfg = {
						success: (res) => {
							if (res.config.params.url && res.config.params.url.indexOf('checkresult_zip') > -1) {
								// 请求流的接口直接返回
								return res;
							} else {
								if (res.data.ret === 0 && _get(res.data, 'data.response.status') == 200) {
									return res.data.data;
								}
								// this.errorHandler(res.data);
								return Promise.reject(res.data);
							}
						},
						error: (error) => {
							// this.errorHandler(error);
							return Promise.reject(error);
						},
					};
					this.interceptorsProxyFn(null, responseCfg);
				});
			});
		} catch (error) {
			throw error;
		}
	}
	errorHandler(error) {
		let errorMsg;
		if (error.__CANCEL__) {
			errorMsg = intl.formatMessage({ id: 'CancelRequest' });
		} else {
			errorMsg = intl.formatMessage({ id: 'NetworkError' });
		}
		store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
	}
	textExtractV2(file, fileName) {
		return this.post({
			url: this.TRANSFERAPI,
			data: {
				fileName,
				file
			},
			config: {
				params: {
					url: '/checkx/v2/textextract',
					'access-token': store.userStore.token
				}
			}
		})
	}
	doDbCheck(params) {
		return this.post({
			url: this.TRANSFERAPI,
			data: {
				...params
			},
			config: {
				params: {
					url: '/check/dbcheck',
					retryTimes: 3,
					'access-token': store.userStore.token
				}
			}
		})
	}
	dbCheckQuery(checkId) {
		return this.get({
			url: this.TRANSFERAPI,
			config: {
				params: {
					url: `/checkx/dbcheckquery?checkId=${checkId}`,
					'access-token': store.userStore.token
				}
			}
		})
	}
	checkResultPdfReport(checkId, reportType = 'originalText') {
		return this.get({
			url: this.TRANSFERAPI,
			config: {
				params: {
					url: `/checkx/checkresult_pdfreport?checkId=${checkId}&reportType=${reportType}`,
					'access-token': store.userStore.token
				}
			}
		})
	}
	checkResultZip(checkId) {
		return this.get({
			url: this.TRANSFERAPI,
			config: {
				params: {
					url: `/checkx/checkresult_zip?checkId=${checkId}`,
					isOutputResult: 1,
					'access-token': store.userStore.token
				},
				responseType: 'blob'
			}
		})
	}
}
